import PropTypes from 'prop-types'
import {
  Wrapper as AmbWrapper, Button as AmbButton,
  Menu as AmbMenu, MenuItem as AmbMenuItem }
  from 'react-aria-menubutton'
import { Link } from 'react-router'

import SegmentOptionRow from 'components/campaign/NewCampaign/SegmentOptionRow'
import {
  AnonymousOption,
  EveryoneOption,
  IdentifiedUsersOption
} from './AudienceOption'
import { getSegmentSelection } from 'utils/SegmentSelectHelper'
import EditableAreaStyles from 'components/CampaignWizards/MessageUsers/Compose/EditableArea/style'

import styles from './style'

/**
 * return all the segment rows and the selected one if any
 * @param segments
 * @param users
 * @param selectedSegmentId
 * @returns {{rows: Nodes, selected: Node|null}}
 */
function renderSegmentOptions(segments, users, selectedSegmentId) {
  let selected
  const rows = segments.map((segment) => {
    const row = <SegmentOptionRow segment={ segment } author={ users[segment.authorId] }/>
    if (selectedSegmentId === segment.id) {
      selected = row
    }
    return (
      <AmbMenuItem
        key={ segment.id }
        value={ segment.id }
        text={ segment.name }
      >
        { row }
      </AmbMenuItem>
    )
  })
  return { rows, selected }
}

function getSelectedAudienceOption(selectedSegmentId) {
  switch (selectedSegmentId) {
    case "VISITORS":
      return AnonymousOption
    case "EVERYONE":
      return <EveryoneOption />
    case "USERS":
      return <IdentifiedUsersOption />
    default:
      return "Pick a segment"
  }
}

export const SegmentPreviewLink = ({ segmentId }) => {
  return (
    <Link
      to={`/contacts/segments/${segmentId}`}
      target="_self"
      className="link dsg-Regular"
    >
      Preview segment
    </Link>
  )
}
SegmentPreviewLink.propTypes = {
  segmentId: PropTypes.number.isRequired
}

/**
 * Render SegmentSelect for a wizard.
 * @param onSelection
 * @param selectedSegmentId
 * @param isSlider, used for business logic, when true AnonymousOption is available
 * @param users
 * @param segments
 * @returns {XML}
 * @constructor
 */
const SegmentSelect = ({ onSelection, selectedSegmentId, isSlider, users, segments }) => {
  const previewLink = selectedSegmentId && Number.isInteger(selectedSegmentId)
      ? <SegmentPreviewLink segmentId={ selectedSegmentId }/>
      : null
  const segmentsToRender = getSegmentSelection(selectedSegmentId, segments)
  const { rows, selected } = renderSegmentOptions(segmentsToRender, users, selectedSegmentId)
  const selectedOption = selected || getSelectedAudienceOption(selectedSegmentId)

  return (
    <div key="segmentId" className={ `${EditableAreaStyles.InputWrapper} ${styles.TargetingAudience}` }>
      <div className="flex-space-between">
        <label className="dsg-Label color-navy-dark">Segment</label>
        { previewLink }
      </div>
      <AmbWrapper
        className="AriaMenuButton AriaMenuButton--large nm-segment-select"
        onSelection={onSelection}
      >
        <AmbButton>
          <div className="content">{ selectedOption }</div>
        </AmbButton>
        <AmbMenu>
          { isSlider ? <EveryoneOption /> : null }
          { isSlider ? <IdentifiedUsersOption /> : null }
          { isSlider ? AnonymousOption : null }
          { rows }
        </AmbMenu>
      </AmbWrapper>
    </div>
  )
}
SegmentSelect.propTypes = {
  onSelection: PropTypes.func.isRequired,
  selectedSegmentId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  isSlider: PropTypes.bool,
  users: PropTypes.object.isRequired,
  segments: PropTypes.array.isRequired
}

export default SegmentSelect



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/SegmentSelect.js